import { Wrench, Car, KeyRound, Lock, Droplets, Home, Zap, Truck, ShieldCheck } from "lucide-react";

export const NAV_LINKS = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "Features", href: "#features" },
  { label: "Services", href: "#services" },
  { label: "For Providers", href: "#providers" },
  { label: "Launch Cities", href: "#launch-cities" },
  { label: "FAQ", href: "#faq" },
];

export const PROBLEMS = [
  { icon: Car, label: "Flat tire" },
  { icon: Zap, label: "Dead battery" },
  { icon: KeyRound, label: "Vehicle lockout" },
  { icon: Lock, label: "Home lockout" },
  { icon: Droplets, label: "Plumbing leak" },
  { icon: Wrench, label: "Need a locksmith" },
  { icon: Home, label: "Emergency repair" },
];

export const STEPS = [
  { n: "01", title: "Tell us what's wrong", body: "Select your problem or describe what happened in your own words.", screen: "chat" },
  { n: "02", title: "SOSConnect AI understands", body: "AI identifies the service you need and guides you through the request.", screen: "ai" },
  { n: "03", title: "Find nearby help", body: "We connect you with relevant, trusted providers close to you.", screen: "providers" },
  { n: "04", title: "Stay updated", body: "Follow your request live and see real-time provider updates.", screen: "tracking" },
  { n: "05", title: "Problem solved", body: "Complete the service, handle payment, and leave feedback.", screen: "done" },
];

export const FEATURES = [
  { title: "AI-Powered Assistance", body: "Explain what happened naturally and SOSConnect AI guides you to the right type of service.", tag: "AI" },
  { title: "Nearby Providers", body: "Discover trusted providers relevant to your problem and your exact location.", tag: "Live" },
  { title: "Live Service Updates", body: "Stay informed while a provider is on the way and responding to your request.", tag: "Live" },
  { title: "Trusted Reviews", body: "View ratings and real customer feedback before selecting who helps you.", tag: "" },
  { title: "Multiple Services", body: "Roadside, locksmiths, plumbing, home services and more — one platform.", tag: "" },
  { title: "Simple Payments", body: "A streamlined service and payment experience without unnecessary steps.", tag: "" },
];

export const SERVICES = [
  { icon: Truck, label: "Roadside Assistance" },
  { icon: Truck, label: "Towing" },
  { icon: Car, label: "Flat Tire Help" },
  { icon: Zap, label: "Jump Starts" },
  { icon: KeyRound, label: "Vehicle Lockouts" },
  { icon: ShieldCheck, label: "Locksmiths" },
  { icon: Lock, label: "Home Lockouts" },
  { icon: Droplets, label: "Plumbing" },
  { icon: Droplets, label: "Leaks" },
  { icon: Home, label: "Emergency Home Services" },
];

export const PROVIDER_BENEFITS = [
  "Receive nearby service opportunities",
  "Reach customers when they actually need your service",
  "Manage incoming requests",
  "Assign jobs to your workers",
  "Build your reputation through reviews",
  "Grow your customer base",
  "Join new markets as SOSConnect AI expands",
];

export const SERVICE_CATEGORIES = [
  "Roadside Assistance", "Towing", "Flat Tire Help", "Jump Starts",
  "Vehicle Lockouts", "Locksmith", "Home Lockouts", "Plumbing",
  "Leak Repair", "Emergency Home Services", "HVAC", "Electrical",
];

export const COMPARISON = {
  old: ["Search Google", "Call multiple businesses", "Ask if someone is available",
    "Explain the problem repeatedly", "Wait for callbacks", "Compare businesses manually"],
  new: ["Explain the problem once", "Discover relevant nearby help", "Compare providers",
    "Stay updated in real time", "Manage your service from one place"],
};

export const FAQS = [
  { q: "What is SOSConnect AI?", a: "SOSConnect AI is an AI-powered emergency services marketplace that helps you quickly find and connect with nearby trusted providers for roadside emergencies, lockouts, plumbing, home services and other urgent everyday problems." },
  { q: "How does SOSConnect AI work?", a: "You describe what's wrong, our AI identifies the type of help you need, and we connect you with relevant nearby providers. You then track the service live from request to completion." },
  { q: "When will SOSConnect AI launch?", a: "We're launching soon. Join the early access list to be notified the moment SOSConnect AI is available near you." },
  { q: "Where will SOSConnect AI launch first?", a: "We launch first in the cities with the strongest combined customer and provider demand. Request your city to help move it up the list." },
  { q: "How can I request my city?", a: "Use any of the location forms on this page to add your city. The more people who request your city, the higher it ranks on our launch leaderboard." },
  { q: "What services will SOSConnect AI support?", a: "Roadside assistance, towing, flat tire help, jump starts, vehicle and home lockouts, locksmiths, plumbing, leak repair and emergency home services — with more categories on the way." },
  { q: "How does SOSConnect AI find providers?", a: "We match your request and location with trusted providers whose services and coverage area fit your situation." },
  { q: "Does SOSConnect AI provide the services itself?", a: "No. SOSConnect AI is a platform that connects you with independent, vetted service providers — it helps manage the entire experience end to end." },
  { q: "How can my business become a provider?", a: "Visit our provider application page and apply to join. Approved businesses are among the first available when we launch in their area." },
  { q: "Will SOSConnect AI be available on iPhone and Android?", a: "Yes. SOSConnect AI is being built for both iPhone and Android." },
];
